import { AuthGuard } from './../../shared/guards/authGuard/auth.guard';
import { DetalleGrupoDiscapacidadComponent } from './detalle-grupo-discapacidad.component';
import { ConfiguracionDiscapacidadComponent } from './configuracion-discapacidad.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '', component: ConfiguracionDiscapacidadComponent
  }
  , {
    path: 'detalle-grupo-discapacidad', component: DetalleGrupoDiscapacidadComponent, canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfiguracionDiscapacidadRoutingModule { }
